import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-md border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-600">
          {/* Copyright */}
          <p>© 2025 AutomateSEO.ai. All rights reserved.</p>

          {/* Links */}
          <div className="flex items-center gap-6">
            <button
              onClick={() => navigate('/privacy')}
              className="hover:text-blue-600 transition-colors"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate('/terms')}
              className="hover:text-blue-600 transition-colors"
            >
              Terms of Service
            </button>
            <button
              onClick={() => navigate('/help-center')}
              className="hover:text-blue-600 transition-colors"
            >
              Help Center
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AuthFooter;
